import {Layers, Target, FlaskConical, TrendingUp} from 'lucide-react'

const PILLARS = [
  {
    icon: Target,
    title: 'Get a ripped body the smart way',
    body: 'Getting ripped is not starvation — it is a calibrated caloric deficit paired with hard resistance training. Our calculator sets a deficit between 15% and 25% so you keep strength while body fat falls, the exact recipe to get ripped without the crash.',
  },
  {
    icon: Layers,
    title: 'Shredding and bulking, decoded',
    body: 'Understanding shredding and bulking is what separates a bodybuilder shredded for stage from someone spinning their wheels. Bulk to build the engine, then shred to reveal it. This tool handles the shred phase with surgical precision.',
  },
  {
    icon: FlaskConical,
    title: 'Lean to ripped, backed by science',
    body: 'Going from lean to ripped means protecting muscle as you diet down. We bias protein to roughly 1.1g per pound of lean mass and use Katch-McArdle when body fat is known — the gold standard for shredding in bodybuilding.',
  },
  {
    icon: TrendingUp,
    title: 'A lean and ripped body, sustained',
    body: 'A lean ripped body is built on consistency, not extremes. Your blueprint includes realistic timelines and hydration targets so the lean ripped result you earn actually sticks long after the diet ends.',
  },
]

function SeoContent() {
  return (
    <section id="guide" className="relative py-20 lg:py-28 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <header className="max-w-3xl">
          <span className="font-mono text-[13px] uppercase tracking-[0.2em] text-blue-500">
            The Shred Guide
          </span>
          <h2 className="font-display mt-3 text-[34px] sm:text-[44px] font-bold tracking-[-0.02em] text-white">
            How to shred muscle fat and stay lean and ripped
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-slate-400">
            If you have ever thought <em className="text-slate-200 not-italic font-medium">"I want to get ripped"</em>{' '}
            but did not know where to start, you are in the right place. Shredding in bodybuilding is
            a measurable process: control energy balance, train with intensity, and let the numbers
            guide you to a shredded lean body. Below is everything that powers a successful shred.
          </p>
        </header>

        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {PILLARS.map((p) => {
            const Icon = p.icon
            return (
              <article
                key={p.title}
                className="rounded-3xl border border-white/[0.07] bg-white/[0.02] p-7 hover:border-white/15 transition-colors"
              >
                <span className="grid place-items-center w-12 h-12 rounded-2xl bg-blue-600/15 border border-blue-500/20 text-blue-400">
                  <Icon className="w-6 h-6" aria-hidden="true" />
                </span>
                <h3 className="font-display text-[20px] font-semibold text-white mt-5">
                  {p.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-slate-400">{p.body}</p>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default SeoContent
